import { gql } from '@apollo/client'

export default gql`
  fragment ContractValidityInYear on Contract {
    id
    validFrom
    validTo
    cancellationTo
  }
`
